import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { Customer, DeliveryLocationListConfigService } from 'gung-standard';
import { JeevesDeliveryLocationListCardComponent } from '../../components/jeeves-delivery-location-list-card/jeeves-delivery-location-list-card.component';

@Injectable({
  providedIn: 'root'
})
export class JeevesDeliveryLocationListConfigService extends DeliveryLocationListConfigService {
  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => JeevesDeliveryLocationListCardComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Customer list'
      }
    ];
  }
}
